import React, { useState } from "react"
import {Modal, ProgressBar, Input, Button, Card} from 'react-onsenui';
import styles from './index.module.css'
import { useDeviceNameState } from "../Common/TabPanel/DeviceName/useDeviceName";
import ValidationResult from "../Common/ValidationResult";
import { useShowValidationResult } from "../Common/ValidationResult/useShowValidationResult";
import TabPanel from "../Common/TabPanel";
import { useScansState } from "../HistoryTabPanel/useScans";
import validateTicket from "../../utils/validateTicket";

const ManualEnterTabPanel = () => {

    const scans = useScansState()
    const [loading, setLoading] = useState(false)
    const [code, setCode] = useState(null)
    const deviceName = useDeviceNameState()

    const {setShowValidationResult} = useShowValidationResult()

    const [currentScan, setCurrentScan] = useState()

    const handleSubmit = async (data) => {
        if (data) {
            if (!loading) {
                setLoading(true)

                const scan = await validateTicket(data, deviceName.get())

                setCurrentScan(scan)
                scans.merge([scan])

                setLoading(false)
                setShowValidationResult(true)
            }
        } else {
            setCode('')
        }
    }

    return (
        <TabPanel>

            <label className={styles.label}>Enter ticket code manually</label>

            <div className={styles.info}>
                <p>The code is located under the QR code.</p>
                <p>The format is XXX-YYY-ZZZZZZ.</p>
            </div>

            <Card class={styles.fieldBox}>
                {code === '' &&
                    <div className={styles.error}>Code can't be blank</div>
                }
                <Input
                    value={code}
                    onInput={(event) => setCode(event.target.value?.toUpperCase())}
                    class={styles.field}
                    modifier='large'
                    placeholder='Code'
                />
            </Card>

            <Button
                class={styles.validateButton}
                modifier="large"
                disabled={code === ''}
                onClick={() => handleSubmit(code)}
            >
                Validate
            </Button>


            <Modal isOpen={loading}>
                Validating ticket with Starstream's servers...
                <ProgressBar indeterminate/>
            </Modal>

            <ValidationResult
                scan={currentScan}
                onClickNext={() => setCode(null)}
            />
        </TabPanel>
    )
}

export default ManualEnterTabPanel
